import { INPUT_FORM_ARGS, Metadata, pick } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/label.gjs';

const METADATA = Metadata.define({
  description: 'Label for dropdown list components',
  extends: [pick(INPUT_FORM_ARGS, ['label'])],
  name: 'Dropdown List Label',
});

export default class SpdsInputDropdownListLabel extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-input-dropdown-list-label';

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-input-dropdown-list-label
      id={{this.id}}
      ...attributes
      {{this.validateArguments}}
    >
      {{#if @label}}
        {{@label}}
      {{else}}
        {{yield}}
      {{/if}}
    </FlexRow>
  </template>
}

export const DROPDOWN_LIST_LABEL_METADATA = SpdsInputDropdownListLabel.metadata;
